import { getIn, useFormikContext } from 'formik';
import { useEffect } from 'react';
export const CountryChangeHandler = ({ countries, setActiveCountry }) => {
    const { values } = useFormikContext();
    useEffect(() => {
        const selectedCountry = getIn(values, 'address.idCountry');
        if (!selectedCountry || !countries) {
            return;
        }
        const countryById = countries.find(country => country.idCountry === parseInt(selectedCountry, 10));
        countryById && setActiveCountry(countryById);
    }, [values, countries]);
    return null;
};
